angular.module('callX').service('GoogleAdwordsService', ['$http', '$rootScope', 'UserService',
  function ($http){

    var getPublisherStatus = function(id, callbacks){
      $http.get("/japi/adwords/publisher/"+id)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getAccessURL = function(callbacks){
      $http.get("/japi/adwords/generate/accessurl")
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

     var getCustomerId = function(id, callbacks){
      $http.get("/japi/adwords/publisher/allclients/"+id)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var confirmAccount = function(pubId, custId, callbacks){
      $http.put("/japi/adwords/publisher/access/confirm/"+pubId+"?id="+custId)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var activatePublisher = function(id, data, callbacks){
      $http.post("/japi/adwords/publisher/access/"+id, data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var activatePublisher = function(id, data, callbacks){
      $http.post("/japi/adwords/publisher/access/"+id, data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getCustomerInfo = function(id,callbacks){
      $http.post("/japi/integration/customer/info/"+id)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };

    var getPromoNumbers = function(id,callbacks){
      $http.get("/japi/adwords/publisher/alldetails/"+id)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
     var savePromoNumber = function(id,data,callbacks){
      $http.post("/japi/adwords/publisher/update/userintegrate/"+id,data)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
    var deleteAccount = function(id,callbacks){
      $http.delete("/japi/adwords/deactivate/"+id)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
    var getPromoGranularData = function(pubId,sId,calls,activeDate,dateRangeValue,callbacks){
      console.log(activeDate,dateRangeValue,"activeDate,dateRangeValue in sservice")
      var _data = {
        id: pubId,
        sid: sId,
        rank: calls,
        ref: activeDate,
        ref_from: dateRangeValue[0],
        ref_to: dateRangeValue[1]
      };
      $http.get("/japi/report-chart-granular-adwords/publisher", {params: _data})
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
    return {
      getPublisherStatus: function (id, callbacks) {
        getPublisherStatus(id, callbacks);
      },
      getAccessURL: function (callbacks) {
        getAccessURL(callbacks);
      },
      getCustomerId: function (id, callbacks) {
        getCustomerId(id, callbacks);
      },
      confirmAccount: function (pubId, custId, callbacks) {
        confirmAccount(pubId, custId, callbacks);
      },
      activatePublisher: function (id, data, callbacks) {
        activatePublisher(id, data, callbacks);
      },
      getCustomerInfo: function (id, callbacks) {
        getCustomerInfo(id, callbacks);
      },
      getPromoNumbers: function (id, callbacks) {
        getPromoNumbers(id, callbacks);
      },
      savePromoNumber: function (id, data, callbacks) {
        savePromoNumber(id, data ,callbacks);
      },
      deleteAccount: function (id, callbacks) {
        deleteAccount(id, callbacks);
      },
      getPromoGranularData: function (pubId,sId,calls,activeDate,dateRangeValue, callbacks) {
        getPromoGranularData(pubId,sId,calls,activeDate,dateRangeValue, callbacks);
      }

    };
  }]);